import * as React from 'react';
import { useChatTranslation } from 'hooks/useChatTranslation';
import styles from './LeaveMessageDisplay.module.css';

interface ContactInfo {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
}

interface LeaveMessageDisplayProps {
  message: string;
  contactInfo: ContactInfo;
}

export const LeaveMessageDisplay: React.FC<LeaveMessageDisplayProps> = ({
  message,
  contactInfo,
}) => {
  const { t } = useChatTranslation();

  return (
    <div className={styles.leaveMessage}>
      <div className={styles.header}>
        <div className={styles.icon}>📞</div>
        <h3 className={styles.title}>{t('Contact Request')}</h3>
      </div>

      <div className={styles.contactSection}>
        <h4 className={styles.sectionTitle}>{t('Contact Information')}</h4>
        <div className={styles.contactGrid}>
          {(contactInfo.first_name || contactInfo.last_name) && (
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>{t('Name')}</span>
              <span className={styles.contactValue}>
                {contactInfo.first_name} {contactInfo.last_name}
              </span>
            </div>
          )}

          {contactInfo.email && (
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>{t('Email')}</span>
              <span className={styles.contactValue}>{contactInfo.email}</span>
            </div>
          )}

          {contactInfo.phone && (
            <div className={styles.contactItem}>
              <span className={styles.contactLabel}>{t('Phone')}</span>
              <span className={styles.contactValue}>{contactInfo.phone}</span>
            </div>
          )}
        </div>
      </div>

      <div className={styles.messageSection}>
        <h4 className={styles.sectionTitle}>{t('Message')}</h4>
        <div className={styles.messageContent}>{message}</div>
      </div>
    </div>
  );
};
